import { BaseIcon } from './BaseIcon';

export default class HamburgerIcon extends BaseIcon {
    name() { return 'menu'; };
}
